module.exports = __webpack_public_path__ + "img/ultra_2_03.7adf23b1.jpg";